import { render } from "./etUploadVideo.vue?vue&type=template&id=c1221e8a&scoped=true"
import script from "./etUploadVideo.vue?vue&type=script&lang=js"
export * from "./etUploadVideo.vue?vue&type=script&lang=js"

import "./etUploadVideo.vue?vue&type=style&index=0&id=c1221e8a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1221e8a"]])

export default __exports__